export enum SurfacelogSignalTypes {
  Height = 'H',
  DeltaHeight = 'dH',
  Passcount = 'PC',
  NoLicence = 'H',
  Default = 'H',
  OutsideReferenceModel = 'OUTSIDE_REFERENCE_MODEL'
}